interface IconProps {
  size: number;
  style?: object;
}
function TourSignIcon({ size, style }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 40 40`}
      style={style}
    >
      <g fillRule="evenodd" clipPath="url(#clip0_1_18)" clipRule="evenodd">
        <path
          fill="#E72663"
          d="M20.625 35a1.25 1.25 0 012.5 0v1.25c0 .69-.56 1.25-1.25 1.25h-3.75c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h3.75c.69 0 1.25.56 1.25 1.25V30a1.25 1.25 0 01-2.5 0V5h-1.25v30h1.25z"
        ></path>
        <path
          fill="#F4B943"
          fillOpacity="0.5"
          d="M33.125 6.25h-11.25v6.25h11.25l3.125-3.125-3.125-3.125z"
        ></path>
        <path
          fill="#E72663"
          d="M34.009 5.365A1.251 1.251 0 0033.125 5h-11.25c-.69 0-1.25.56-1.25 1.25v6.25c0 .69.56 1.25 1.25 1.25h11.25c.331 0 .65-.132.884-.366l3.125-3.125a1.25 1.25 0 000-1.769l-3.125-3.125zM23.125 7.5v3.75h9.483l1.875-1.875L32.608 7.5h-9.483zM6.875 8.75c-.331 0-.65.131-.884.365L2.866 12.24a1.25 1.25 0 000 1.769l3.125 3.125c.235.234.553.366.884.366h11.25c.69 0 1.25-.56 1.25-1.25V10c0-.69-.56-1.25-1.25-1.25H6.875zm.518 2.5l-1.875 1.874L7.393 15h9.482v-3.75H7.393zM10 37.5h20a1.25 1.25 0 000-2.5H10a1.25 1.25 0 000 2.5z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1_18">
          <path fill="#fff" d="M0 0H40V40H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default TourSignIcon;
